



























import Vue, { PropType } from 'vue'
import { Actions } from '@/shared/Actions'

export default Vue.extend({
  props: {
    roomId: {
      type: String as PropType<string>,
      required: true
    }
  },
  data: () => ({
    form: {
      name: null,
      surname: null
    }
  }),
  computed: {
    isRegistrationRequestProcessing(): boolean {
      return this.$store.state.isProcessing[Actions.REGISTER_STUDENT][this.roomId] || false
    },
    userUUID(): string {
      return this.$store.state.user.uuid
    },
    formRules() {
      return {
        name: [
          {
            required: true,
            message: 'Podaj imię!',
            trigger: 'blur'
          }
        ],
        surname: [
          {
            required: true,
            message: 'Podaj nazwisko!',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    handleAdd(): void {
      ;(this.$refs.form as any)?.validate()
      if (this.form.name && this.form.surname) {
        const student = {
          // @ts-ignore
          name: this.form.name.trim(),
          // @ts-ignore
          surname: this.form.surname.trim(),
          addedBy: this.userUUID
        }
        this.$emit('onRegister', student)
        this.clearForm()
      }
    },
    clearForm(): void {
      this.form.name = null
      this.form.surname = null
    }
  }
})
